import { render, staticRenderFns } from "./ManagementSystemReportsTable.vue?vue&type=template&id=0e1eb3a8&"
import script from "./ManagementSystemReportsTable.vue?vue&type=script&lang=js&"
export * from "./ManagementSystemReportsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports